import useTranslation, { format } from '../../../../hooks/useTranslation';
import useEditLoanPaymentDay from '../hooks/useEditLoanPaymentDay';

export const MIN_DAY = 1;
export const MAX_DAY = 28;
export const GRACE_DAYS = 5;

const useValidatePaymentDate = (nextPaymentDate: Date) => {
    const translate = useTranslation();
    const targetRange = useEditLoanPaymentDay(nextPaymentDate);

    return (targetDay: number | undefined) => {
        const { errors } = translate.loanEdit;

        if (typeof targetDay !== 'number') {
            return errors.mustChooseDate;
        }

        if (!targetRange.canChange) {
            return errors.paymentDayDefaultError;
        }

        if (targetDay === nextPaymentDate.getDate()) {
            return errors.alreadyChosen;
        }

        if (targetDay < targetRange.targetMinDay) {
            return format(errors.biggerThan, targetRange.targetMinDay);
        }

        if (targetDay > MAX_DAY) {
            return format(errors.lessThan, MAX_DAY);
        }

        return null;
    };
};

export default useValidatePaymentDate;
